var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnectIcon1Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.5V5C15 4.44772 14.5523 4 14 4H3C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H14C14.5523 20 15 19.5523 15 19V15.5",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12H21.5M21.5 12L19 9M21.5 12L19 15",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon1Dark);
export default __webpack_public_path__ + "static/media/disconnect_icon_1_dark.1be8a4ac06b2fadb246f24206256d0f5.svg";
export { ForwardRef as ReactComponent };